module.exports = __webpack_public_path__ + "static/media/stockhausen_haut_21.405d8ec9.jpg";